import React, { Component } from "react";
import NegotiateComponent from "./NegotiateComponent";
import Axios from "axios-https-proxy-fix";
import { Redirect } from "react-router-dom"; //make sure to import all the components.
//redux
import { connect } from "react-redux";

export class Negotiations extends Component {
	/*
    props structure:
    {
        customer_name,
        project_title,
        consultant_name,
        warehouse,
        ship_to,
        products: {
            [id]: {
                sku,
                model,
				en_description,
                fr_description,
                list,
                standard_cost,
                unit_net,
                extended_net
            }
        },
        rooms : {
            [id]: {
                title,
                products: [
					[id]: quantity
                ]
            }
        }
    }
    */
	constructor(props) {
		super(props);

		this.state = {
			products: {},
			rooms: {},
			order: []
		};
	}
	componentDidMount = async () => {
		let APIUrl = this.props.APIUrl + "/projects/fetch-negotiations";
		let data = {
			projectId: this.props.projectId,
		};
		let APIResponse = await Axios.post(APIUrl, data);
		this.setState(state => APIResponse.data);
	};
	render() {
		// Set to redirect if no project chosen
		let redirect = !this.props.projectId ? <Redirect to="/search-projects" /> : null;
		return (
			<React.Fragment>
				{redirect}
				<NegotiateComponent project_ID={this.props.projectId} APIUrl={this.props.APIUrl} customer_name={this.state.customer_name} project_title={this.state.project_title} consultant_name={this.state.consultant_name} warehouse={this.state.warehouse} ship_to={this.state.ship_to} products={this.state.products} rooms={this.state.rooms} updated={this.state.updated} order={this.state.order} notInWarehouseProduct={this.state.notInWarehouseProduct} />
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	projectId: state.projectIdUsedToIncreaseProductQuantity,
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Negotiations);
